export const validateEmail = (email: string) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const validateNumberRange = (input: string) => {
    const match = input.match(/\b\d+-\d+\b/g);
    let isValid = false;

    if (match && match.length === 1) {
        const splitedInput = input.split('-');
        (+splitedInput[0] < +splitedInput[1]) && (isValid = true)
    }

    return isValid;
};

export const validateGPA = (GPA: string) => {
    return GPA.match(/^[0-4]\.\d$/) && +GPA <= 4;
};

export const validateZipCode = (zipCode: string) => {
    return zipCode.match(/^\d{5}(?:[-\s]\d{4})?$/);
};

interface ObjectType {
    [key: string]: any;
}

export const objectToFormData = (obj: ObjectType): FormData => {
    const formData = new FormData();
    Object.keys(obj).forEach(key => formData.append(key, obj[key]));
    return formData;
}

export const objectURLToBlob = async (objectURL: string): Promise<Blob> => {
    let blob = await fetch(objectURL).then(r => r.blob());
    return blob;
};

export const objectURLToFile = async (objectURL: string, fileName: string, type: string): Promise<File> => {
    let blob = await fetch(objectURL).then(r => r.blob());
    const file = new File([blob], fileName, { type });
    return file;
};

export const toTime = (number: number) => {
    const minutes = Math.floor(number / 60);
    const sec = number - minutes * 60;
    const seconds = sec < 10 ? `0${sec}` : sec
    const hours = Math.floor(number / 3600);

    return {
        seconds,
        minutes,
        hours,
    };
};

export function isValidURL(url: string) {
    const pattern = /^((ftp|http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/;
    return pattern.test(url);
};

export function dataURLtoFile(dataurl: string, filename: string) {
    const arr = dataurl.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    const file = new File([u8arr], filename, { type: mime });

    // // ⬇️ Trigger download
    // const url = URL.createObjectURL(file);
    // const link = document.createElement('a');
    // link.href = url;
    // link.download = filename;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // URL.revokeObjectURL(url); // Clean up

    return file;
};

export function convertImageToPng(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        if (!file.type.startsWith('image/')) {
            return reject(new Error('The file is not an image.'));
        }

        const img = new Image();
        const reader = new FileReader();

        reader.onload = () => {
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext('2d');
                if (!ctx) return reject(new Error('Could not get canvas context.'));

                ctx.drawImage(img, 0, 0);
                const dataUrl = canvas.toDataURL('image/png');
                resolve(dataUrl);
            };

            img.onerror = () => reject(new Error('Image loading failed.'));
            img.src = reader.result as string;
        };

        reader.onerror = () => reject(new Error('File reading failed.'));
        reader.readAsDataURL(file);
    });
};

export const camelCaseToSpacedString = (status: string) => {
    return status.replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Handle consecutive capitals
        .toLowerCase() // Convert all to lowercase first
        .replace(/^./, str => str.toUpperCase()) // Capitalize only first letter
        .trim(); // Remove any extra spaces
};